import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import "./Calculator.scss";
import CarFeatures from "./CarFeatures";
import Budget from "./Budget";
import Appointment from "./Appointment";
// import WearPieces from "./WearPieces";
// import Financing from "./Financing/Financing";
import ToyotaLife from "./ToyotaLife/ToyotaLife";

export default class Calculator extends Component {
  constructor() {
    super();
    this.state = {
      pieces: {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false
      },
      showLastSteps: false
    };
  }

  buscadorConcesionadioRedirect = () => {
    window.open(
      "https://www.lexusauto.es/concesionarios"
      // "https://www.toyota.es/#/ajax/%2Fforms%2Fforms%3Ftab%3Dpane-dealer%26showAllResults%3Dtrue"
    );
  };

  scrollToBudget = () => {
    let elmnt = document.getElementById("scroll-budget");
    setTimeout(() => {
      elmnt && elmnt.scrollIntoView();
    }, 900);
  };

  showLastStepsToggle = () => {
    this.setState({ ...this.state, showLastSteps: true }, () => {
      this.scrollToBudget();
      this.props.setAppBarState(2, 2, 2, 1);
    });
  };


  render() {
   
    if (!this.props.carInfo && !this.props.selectedModel) {
      return <Redirect to="/" />;
    }

    return (
      <React.Fragment>
       
        <CarFeatures
          getCarFeaturesValues={this.props.getCarFeaturesValues}
          selectedModel={this.props.selectedModel}
          resetRedirect={this.props.resetRedirect}
          carInfo={this.props.carInfo}
          allCarsInfo={this.props.allCarsInfo}
          setAppBarState={this.props.setAppBarState}
          getModelByRegistration={this.props.getModelByRegistration}
          selectedWorkshops={this.props.selectedWorkshops}
          showLastStepsToggle={this.showLastStepsToggle}
          distanceOptions={this.props.distanceOptions}
          getBudgetToApp={this.props.getBudgetToApp}
          fuelSelected={this.props.fuelSelected}
          gearBoxNameSelected={this.props.gearBoxNameSelected}
          engineNameSelected={this.props.engineNameSelected}
          yearSelected={this.props.yearSelected}
          distanceSelected={this.props.distanceSelected}
          wearPiecesInfo={this.props.wearPiecesInfo}
          yearIntervalError={this.props.yearIntervalError}
        />
        {this.state.showLastSteps ? (
          <div id="scroll-budget">
            {
              
              
              
              this.props.maintenanceCost + this.props.wearPartsCost > 0 ?
              (<><Budget
                maintenanceCost={this.props.maintenanceCost}
                precioNoIncluyeAdblue={this.props.precioNoIncluyeAdblue}
                wearPartsCost={this.props.wearPartsCost}
                thingsToDo={this.props.thingsToDo}
                focusTextInput={this.focusTextInput}
                selectedModel={this.props.selectedModel}
                selectedWorkshops={this.props.selectedWorkshops}
                carInfo={this.props.carInfo}
                fuelSelected={this.props.fuelSelected}
              />

              {/* <WearPieces
              ref={this.textInput}
              getWearPiecesByRegistration={
                this.props.getWearPiecesByRegistration
              }
              wearPiecesInfo={this.props.wearPiecesInfo}
              getCarByRegistration={this.props.getCarByRegistration}
              carInfo={this.props.carInfo}
              addTogglePiece={this.props.addTogglePiece}
              pieces={this.props.pieces}
              loading={this.props.loading}
              notFoundPlatePiecesMsg={this.props.notFoundPlatePiecesMsg}
              // notFoundPlateMsg={this.props.notFoundPlateMsg}
            /> */}
            <Appointment
              sendDatosToApp={this.sendDatosToApp}
              carInfo={this.props.carInfo}
              plate={this.props.plate}
              selectedWorkshops={this.props.selectedWorkshops}
              pieces={this.props.pieces}
              wearPiecesInfo={this.props.wearPiecesInfo}
              maintenanceCost={this.props.maintenanceCost}
              wearPartsCost={this.props.wearPartsCost}
              fuelSelected={this.props.fuelSelected}
              gearBoxNameSelected={this.props.gearBoxNameSelected}
              engineNameSelected={this.props.engineNameSelected}
              yearSelected={this.props.yearSelected}
              distanceSelected={this.props.distanceSelected}
              thingsToDo={this.props.thingsToDo}
              selectedModel={this.props.selectedModel}
              precioNoIncluyeAdblue={this.props.precioNoIncluyeAdblue}
            />
            </>
              ) : (
                <>
                <div className="presupuesto_cero">              
                <div className="form-pane with-buttons presupuesto_cero_msg">
                      <p className="error-km-interval-red">
                      Lo sentimos, en este momento no podemos mostrarte un presupuesto estimado de mantenimiento para el vehículo seleccionado.
                      </p>
                      <p className="error-km-interval-black">
                        Por favor,{" "}
                        <b>ponte en contacto con tu concesionario más cercano</b>.
                      </p>
                      {/* <button
                      onClick={this.buscadorConcesionadioRedirect}
                      className="mm-button mm-rounded mm-red">Solicitar cita al concesionario</button> */}

                      <button class="button_mostrar_mas btn-descubrir" type="button" style={{ margin: 0 }} onClick={this.buscadorConcesionadioRedirect}>
                        <span class="btn-vehiculos" style={{ marginLeft: 5 }}>
                          SOLICITAR CITA AL CONCESIONARIO
                        </span>
                        <span class="linea-boton"></span>
                      </button>
                    </div>
                  </div>
                </>
              )
            }
            
            {/* <Financing
              maintenanceCost={this.props.maintenanceCost}
              wearPartsCost={this.props.wearPartsCost}
            /> */}
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}
